import * as Sentry from '@sentry/browser';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './containers/App/App';
import './index.css';

// import registerServiceWorker from "./registerServiceWorker";

const body = document.body;
body.addEventListener('env-loaded', () => {
  Sentry.init({
    dsn: "https://f0bcac0d53c54d31b314f6336e7c41f6@sentry.io/1429113",
    environment: window.ENV
  });
  ReactDOM.render(<App />, document.getElementById('root'));
});



// WEBPACK FOOTER //
// ./src/index.tsx